import MetaDecorator from 'apps/home/components/MetaDecorator';
import apiUserCall from 'apps/investment/apiCalls/user';
import NotificationUserInfo from 'common/notification-user-info';
import { useFetchApiList } from 'hooks/api';
import { useEffect } from 'react';

// The todo lists are paged server-side; 100 is the server's maximum page size.
const PAGE_SIZE = 100;

function UserTodoPage() {
  const {
    data: listUsers2 = [],
    load: loadListUsers2,
    paging: paging2,
  } = useFetchApiList(apiUserCall.requiredResyncEContractLink, {
    resourceName: 'data',
  });

  const {
    data: listUsers3 = [],
    load: loadListUsers3,
    paging: paging3,
  } = useFetchApiList(apiUserCall.requiredResyncVSDStatus, {
    resourceName: 'data',
  });

  useEffect(() => {
    loadListUsers2({ page: 1, page_size: PAGE_SIZE });
    loadListUsers3({ page: 1, page_size: PAGE_SIZE });
  }, []);

  return (
    <>
      <MetaDecorator title={'Admin CP | User Todo'} />
      <div className="space-y-4">
        <NotificationUserInfo
          items={listUsers2}
          paging={paging2}
          onPageChange={page => loadListUsers2({ page, page_size: PAGE_SIZE })}
          title={
            'Tài khoản NHSV chưa khởi tạo eContract thành công. Vui lòng liên hệ IT để được hỗ trợ.'
          }
        />
        <NotificationUserInfo
          items={listUsers3}
          paging={paging3}
          onPageChange={page => loadListUsers3({ page, page_size: PAGE_SIZE })}
          title={'Tài khoản chưa được VSD duyệt sau 24h. Vui lòng kiểm tra'}
        />
      </div>
    </>
  );
}

export default UserTodoPage;
